<template>
  <v-dialog :persistent="true" max-width="1000px" v-model="inDialog">
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
              $t(formName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                  :data-vv-as="$t('lang.groups.groupName')"
                  :error-messages="errors.first('groupName')"
                  :label="$t('lang.groups.groupName')"
                  disabled
                  name="groupName"
                  type="text"
                  v-model.trim="item['groupName']"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-toolbar flat color="white">
            <v-toolbar-title>{{$t('lang.groups.userList')}}</v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <div style="text-align: right">
              <v-btn @click="openUserListWaitingDialog" color="primary">
                <v-icon dark left>add</v-icon>
                {{ $t("lang.common.add") }}
              </v-btn>

            </div>
          </v-toolbar>

          <c-search-form :displayToolbar="false"
                         :fields="fields"
                         :input-create-items="createItems"
                         :input-search-items="searchItems"
                         :reload="timeReload"
                         :rows-per-page-items="[10,20,50]"
                         :search-url="searchUrl"
                         @onDeleteFromGroup="onDeleteFromGroup"
                         form-type="intable"
                         key-property="deputyId"
                         ref="searchTable"
          />
          <div style="text-align: right">
            <v-btn @click="onCancel" color="error">
              <v-icon dark left>cancel</v-icon>
              {{ $t("lang.common.cancel") }}
            </v-btn>
          </div>
        </v-card-text>
        <!-- </v-container> -->
      </v-form>

    </v-card>
  </v-dialog>
</template>

<script>
  import {message} from "../../../services";
  import axios from "axios";
  import CSearchForm from "../../../components/form/ManageForm";

  export default {
    name: "group-user-list",
    components: {axios, CSearchForm},
    props: {
      propsItem: {
        type: Object,
        default: null,
      },
      cDialog: {
        type: Boolean,
        default: false,
      },
      rowsPerPageItems: {
        type: [Array, Number],
        default: () => [10, 20, 30, 40, 50]
      },
      timeReload: {
        type: [Number],
        default: 0
      }
    },
    data: () => {
      return {
        formName: "Danh sách Người dùng trong đơn vị",
        item: {
          customerName: "",
          status: 1,
        },
        inDialog: false,
        searchItems: [],
        createItems: [],
        searchUrl: "",
        fields: [
          {
            value: "index",
            text: "lang.common.index",
            width: "5%",
            sortable: false,
            headerStyle: "text-align:center"
          },

          {
            value: 'fullName',
            text: 'lang.user.fullName',
            width: "20%",
            sortable: false,
            headerStyle: "text-align:left",
            search: true

          },
          {
            value: 'custom_action_list',
            text: "lang.common.actions",
            width: "5%",
            items: [
              {
                text: "lang.common.delete",
                icon: "delete",
                event: "onDeleteFromGroup",
                color: "red"
              },

            ],

          },
        ],
      };
    },
    watch: {
      propsItem: {
        handler(value) {
          if (value !== null) {
            this.item = Object.assign({}, value)
            console.log("groupId", this.item['groupId'])
            this.searchUrl = "/groups/userInGroup/list/" + this.item['groupId']
          } else {
            this.resetFrom();
          }
        },
        deep: true,
      },
      cDialog(value) {
        this.inDialog = value;
      },
      inDialog(value) {
        if (!value) {
          this.$emit("closeDialog", "");
        }
      },
    },
    methods: {
      resetFrom: function () {
        this.item = {
          status: 1,
        };
      },
      onCancel: function () {
        this.$emit("closeDialog", "");
        this.searchUrl = "";
      },
      openUserListWaitingDialog: function (item) {
        item["groupId"] = this.item['groupId'];
        item['status'] =1;
        this.$emit("openUserListWaitingDialog", item);
      },
      onDeleteFromGroup(item) {
        item['status'] = 0;
        axios.post(process.env.VUE_APP_API_URL + "/userGroup/save", item).then(
          data => {
            if (data.success) {
              message.success(this.$t("lang.common.delete_success"));
              this.timeReload = Math.floor(Math.random() * 100);
            } else {
              message.error(data.description);
            }
          }
        )
      },

    },
    created() {

    },
  };
</script>
